// add-address.component.ts
import { Component, OnInit } from '@angular/core';
import { ApiServiceService } from '../../services/api-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AppComponent } from '../../app.component';
import { MatDialogContent } from '@angular/material/dialog';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-add-address',
  templateUrl: './add-address.component.html',
  styleUrl: './add-address.component.scss',
})
export class AddAddressComponent implements OnInit {
  addressIds: any;
  addressDetails: any;
  countries: any;
  public addressUpdate!: FormGroup;
  isEditing = false;
  addressInAddres: any;
  user_id: any;

  constructor(
    private api: ApiServiceService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private Loader: LoaderService
  ) {}

  ngOnInit() {
    this.initializeForms();
    this.getStateByCountry('India');
    this.getAllUserAddress();
  }

  getCurrentUserId(): string {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decodedToken = JSON.parse(atob(token.split('.')[1]));
        return decodedToken.id || ''; // Ensure this matches the field in your payload
      } catch (e) {
        console.error('Error decoding token:', e);
      }
    }
    return '';
  }

  ngAfterViewInit() {
    this.route.params.subscribe((addressid: any) => {
      this.addressIds = addressid['id'];
    });
    this.getAddressById();
  }

  getAddressById() {
    if (!this.addressIds) {
      return;
    }
    this.Loader.showLoader();
    this.api.getAddressById(this.addressIds).subscribe({
      next: (res: any) => {
        this.Loader.hideLoader();
        this.addressDetails = res.data;

        this.addressUpdate
          .get('fullName')
          ?.setValue(this.addressDetails?.delivery_name);
        this.addressUpdate
          .get('mobileNumber')
          ?.setValue(this.addressDetails?.delivery_mobile);
        this.addressUpdate
          .get('city')
          ?.setValue(this.addressDetails?.delivery_city);
        this.addressUpdate
          .get('pinCode')
          ?.setValue(this.addressDetails?.delivery_pincode);
        this.addressUpdate
          .get('buildingHouse')
          ?.setValue(this.addressDetails?.delivery_address);
        this.addressUpdate
          .get('State')
          ?.setValue(this.addressDetails?.delivery_state);
        this.addressUpdate
          .get('country')
          ?.setValue(this.addressDetails?.delivery_country);
        this.addressUpdate
          .get('addressType')
          ?.setValue(this.addressDetails?.addressType);
        this.addressUpdate
          .get('deliveryNotes')
          ?.setValue(this.addressDetails?.deliveryNotes);

        this.isEditing = true;
      },
      error: (error) => {
        console.error('Error fetching address:', error);
      },
    });
  }

  initializeForms() {
    this.addressUpdate = this.fb.group({
      fullName: ['', Validators.required],
      mobileNumber: ['', Validators.required],
      city: ['', Validators.required],
      pinCode: ['', Validators.required],
      buildingHouse: ['', Validators.required],
      State: ['', Validators.required],
      country: ['', Validators.required],
      addressType: ['', Validators.required],
      deliveryNotes: [''],
    });
  }

  addressUpdates() {
    if (this.addressUpdate.valid) {
      let para: any;
      const userId = this.getCurrentUserId();
      if (!this.addressIds) {
        para = {
          user_id: userId, // Use the current user_id
          delivery_id: '',
          delivery_name: this.addressUpdate.value.fullName,
          delivery_address: this.addressUpdate.value.buildingHouse,
          delivery_city: this.addressUpdate.value.city,
          delivery_state: this.addressUpdate.value.State,
          delivery_country: this.addressUpdate.value.country,
          delivery_pincode: this.addressUpdate.value.pinCode,
          delivery_mobile: this.addressUpdate.value.mobileNumber,
          addressType: this.addressUpdate.value.addressType,
          deliveryNotes: this.addressUpdate.value.deliveryNotes,
        };
      } else {
        para = {
          user_id: userId, // Use the current user_id
          delivery_id: this.addressIds,
          delivery_name: this.addressUpdate.value.fullName,
          delivery_address: this.addressUpdate.value.buildingHouse,
          delivery_city: this.addressUpdate.value.city,
          delivery_state: this.addressUpdate.value.State,
          delivery_country: this.addressUpdate.value.country,
          delivery_pincode: this.addressUpdate.value.pinCode,
          delivery_mobile: this.addressUpdate.value.mobileNumber,
          addressType: this.addressUpdate.value.addressType,
          deliveryNotes: this.addressUpdate.value.deliveryNotes,
        };
      }
      this.Loader.showLoader();
      this.api.addAddress(para).subscribe({
        next: (response: any) => {
          this.Loader.hideLoader();

          if (response.message) {
            this.toastr.success('You updated successfully', '', {
              toastClass: 'ngx-toastr toast-custom',
            });
            // 🔹 Check redirect param
            const redirect = this.route.snapshot.queryParamMap.get('redirect');
            if (redirect === 'cart') {
              this.router.navigate(['/steps']);
            } else {
              this.router.navigate(['add-address']);
            }
          } else {
            this.toastr.error('Update failed', '', {
              toastClass: 'ngx-toastr toast-custom',
            });
          }
        },
      });
    }
  }

  countryselected(event: any) {
    const country = event.target.value;
    this.getStateByCountry(country);
  }

  getStateByCountry(country: any) {
    const para = {
      country: country,
    };
    this.api.getStateByCountry(para).subscribe((data: any) => {
      this.countries = data.data[0];
      console.log('countries', this.countries);
    });
  }

  getAllUserAddress() {
    this.api.getAllUserAddress().subscribe((addressData: any) => {
      this.addressInAddres = addressData.data;
    });
  }
}
